var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ServerButton",class:{'ServerButton-isHome':_vm.isHome,'ServerButton-hasNotification': _vm.hasNotification}},[(_vm.mentions)?_c('div',{staticClass:"mentions"},[_vm._v(_vm._s(_vm.mentions))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-267a316e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Server-List/ServerButton.vue
// module id = 43
// module chunks = 0